import { gql } from "@apollo/client";

export const UPDATE_PROFILE = gql`
  mutation UpdateProfile(
    $showInEvent: Boolean
    $smsEnabled: Boolean
    $emailEnabled: Boolean
    $language: String
  ) {
    updateProfile(
      showInEvent: $showInEvent
      smsEnabled: $smsEnabled
      emailEnabled: $emailEnabled
      language: $language
    ) {
      profile {
        showInEvent
        emailEnabled
        smsEnabled
      }
    }
  }
`;

export const UPDATE_PROMOCODE = gql`
  mutation UpdateProfile($promocode: String) {
    updateProfile(promocode: $promocode) {
      profile {
        promocode
      }
    }
  }
`;

export const DELETE_PROFILE = gql`
  mutation DeleteAllProfiles {
    deleteAllProfiles {
      ok
    }
  }
`;

export const CASHBACK_TRANSFER = gql`
  mutation CashbackTransfer {
    cashbackTransfer {
      profile {
        account
        cashbackAccount
      }
    }
  }
`;
